import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import './AdminLayout.css';

function AdminLayout() {
    return (
        <div className="admin-layout">
            <Sidebar />
            <main className="admin-main-content">
                <Outlet /> {/* 이 부분에 자식 라우트 컴포넌트가 렌더링됩니다. */}
            </main>
        </div>
    );
}

export default AdminLayout;